<template>
  <div class="flex qrcode-wrap" style="border-radius: 10px;overflow: hidden;">
    <el-carousel 
      height="200px" 
      :interval="4000" 
      :arrow="'hover'"
      indicator-position="inside"
      class="banner-carousel"
    >
      <el-carousel-item 
        v-for="(banner, index) in bannerList" 
        :key="index"
        class="carousel-item"
      >
        <div class="banner-img" @click="openUrl(banner)">
          <img :src="banner.image" :alt="banner.title" />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { getAds } from '@/api';
export default {
  data() {
    return {
      bannerList: []
    };
  },
  computed: {
    creator() {
      return this.$store.state.creator;
    },
    admin() {
      return this.$store.state.admin;
    },
    corpCertityStatus() {
      return this.$store.state.corpCertityStatus;
    },
    userCertityStatus() {
      return this.$store.state.userCertityStatus;
    },
  },
  created() {
    this.getAdsListFn();
  },
  methods: {
    async getAdsListFn() {
      const response = await getAds({ pageCode: 'etc_pc_home'});
      if (response && response.code === 200) {
        const data = response.data;
        if (data && Array.isArray(data) && data.length > 0) {
          this.bannerList = data;
        }
      } 
    },
    openUrl(banner) {
      var sensors = window['sensorsDataAnalytic201505'];
      sensors.track('banner_click', {
        customProperties: {
          bannerCode: 'pc_etc_guafenxianjin',
        },
      }); 
      window.open(banner.link, '_blank');
    },
  },
};
</script>
<style lang="scss" scoped>
.qrcode-wrap {
  box-sizing: border-box;
}

.banner-carousel {
  width: 100%;
  
  // 自定义轮播图指示器样式
  :deep(.el-carousel__indicators) {
    .el-carousel__indicator {
      .el-carousel__button {
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 50%;
        width: 8px;
        height: 8px;
      }
      
      &.is-active .el-carousel__button {
        background-color: #fff;
      }
    }
  }
  
  // 自定义轮播图箭头样式
  :deep(.el-carousel__arrow) {
    background-color: rgba(0, 0, 0, 0.3);
    border: none;
    color: #fff;
    
    &:hover {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
}

.carousel-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-img {
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    max-width: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
  }
}

// 保留原有样式以防需要
h1 {
  height: 25px;
  font-size: 18px;
  font-weight: 500;
  color: rgba(24, 24, 24, 1);
  line-height: 25px;
  margin-bottom: 21px;
  margin-top: 33px;
}
p {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  margin-bottom: 9px;
}
</style>
